import * as React from "react";
import {ContentIcon, formatSvgString, getSize, IconProps} from "../index";
import SVG from "react-inlinesvg";
import {ContentIcons as CI} from "@laerdal/figma-svg";

export const AedPadsError: React.FunctionComponent<IconProps> = ({
                                                                   className,
                                                                   color = 'currentColor',
                                                                   size = '48px',
                                                                   label = '',
                                                                   viewBox = '0 0 48 48', ...rest
                                                                 }) => (
  <ContentIcon tooltip={label}>
    <SVG src={CI.AedPadsError} height={getSize(size)} width={getSize(size)} {...rest} className={className} viewBox={viewBox}
         preProcessor={content => formatSvgString(content, color)}/>
  </ContentIcon>
);
